import { call, put, select, takeLatest } from "redux-saga/effects";
import * as API from "../../../containers/APIurls";
import apiClient from "../../../utils/apiClient";
import * as BussProductSlice from "./BussProductSlice";
import * as CheckoutSlice from "../../../pages/Checkout/ducks/CheckoutSlice";
import * as GlobalSlice from "../../../app/ducks/GlobalSlice";
import * as selectors from "./selectors";
import Utils from "app/ducks/utils";
import { setAPIError, setError, setGridwallApiCalled, setGridwallList, setPageLoading, setPDPApiCalled, setPdpDeviceDetails, setProductDetail } from "pages/Marketplace/ducks/MarketplaceSlice";

function* accessToShowMarketplace(params) {
	try {
		const requestBody = params.payload
		const response = yield apiClient.post(API.MARKETPLACE_AUTHENTICATION, requestBody);
		if (response?.data && String(response?.data?.statusMessage).toUpperCase() === "ALLOWED") {
			yield put(BussProductSlice.setMArketPlaceAccess(true))
		} else yield put(BussProductSlice.setMArketPlaceAccess(false))

	} catch (e) {
		yield put(BussProductSlice.setMArketPlaceAccess(false))
	} finally {

	}
}

function* addToCart(params) {
	const flow = params?.payload?.flow;
	let exceededCreditLimit = undefined;
	// const plansPayload = {
	//   approach: "",
	//   flow: flow === "one-talk" ? flow : "prospect",
	//   shoppingPath: "PROSPECT",
	// };
	let productDetailsObj = params.payload.productDetailsObj;
	let planFirstFlag = params.payload.planFirstFlag;
	//  let imageSet = ''
	//   delete params?.payload?.productDetailsObj
	//   delete params?.payload?.planFirstFlag
	//   if(params?.payload?.exceedingCreditLimitData){
	//     exceededCreditLimit = params?.payload?.exceedingCreditLimitData
	//     imageSet = params?.payload?.imageSets
	//     delete params?.payload?.imageSets
	//     delete params?.payload?.exceedingCreditLimitData
	//   }
	yield put(BussProductSlice.setAPIError(false));
	// yield put(AccessorySlice.setPageLoading(true));
	yield put(BussProductSlice.setPageLoading(true));
	// yield put(CheckoutSlice.setIsShoppingCartApiCallInProgress({ apiName: "getFetchCart5G", status: true }));
	try {
		const bussProducts = yield select(state => state.ProspectWidgets_BussProductsData.selectedProductBUSS)
		let requestBody = Object.assign({}, params.payload);
		// delete requestBody?.routeToFeatures;
		// const isMixedCart = yield select(state=>state?.GlobalData?.sessionCartData?.isMixedCart)
		// if(isMixedCart) requestBody = {...requestBody,"allowMixedCart":true}
		const response = yield apiClient.post(API.MARKETPLACE_SAVE_PRODUCT, requestBody);
		// yield call(getSharedCartSave, {
		//   payload: { shoppingPath: "PROSPECT", fromUCSubmitOrder: false },
		// });
		// if(planFirstFlag && response?.data?.status?.statusCode ==200){
		//   yield put (PlanFirstSlice.addDeviceToLines(productDetailsObj))
		// }
		// let sessionCartResponse = {
		//   prospectFlowData: response?.data?.response,
		//   serviceStatus: response?.data?.status
		// }
		// if (!response?.data?.status?.success) {
		//   yield put(BussProductSlice.setAddToCartResponse(response?.data));
		//   throw Object.assign(
		//     new Error('Failed to retrieve cart'),
		//     { status: response?.status, data: response?.data }
		//   );
		// } else
		if (response && response.data.success) yield put(BussProductSlice.setIsAddToCartCompleted(true));
		if (response && response.data && response.data.response) {
			let sessionCartResponse = {
				prospectFlowData: response?.data?.response,
				serviceStatus: response?.data?.status,
			};
			const newStore = Utils.setStoreFromRetrieve(sessionCartResponse);
			yield put(GlobalSlice.setSessionCartData(newStore));
			yield put(BussProductSlice.setCartResponse(response?.data?.response));
			yield put(BussProductSlice.setSelectedProduct({ ...bussProducts, [params?.payload['lines'][0]['packageId']]: params?.payload['lines'][0]['quantity'] }))
			// yield put(GlobalSlice.setLoadShoppingCartWidget(true));
		}
		if (exceededCreditLimit && response?.data?.response?.cart?.packages) {
			const key = Object.keys(response?.data?.response?.cart?.packages).find(
				(data) => String(data).includes(exceededCreditLimit)
			);
			// yield put(BussProductSlice.addedDeviceForExceededCredit({...response?.data?.response?.cart?.packages[key],imageSet:imageSet, packageId: key }));
		}
		yield put(BussProductSlice.setMarketplaceSaveProductResp(response.data));
	} catch (err) {
		if (params?.payload?.routeToFailure) {
			params?.payload?.routeToFailure();
		}
		yield put(BussProductSlice.setAPIError(true));
		yield put(BussProductSlice.setPageLoading(false));
	} finally {
		// yield put(AccessorySlice.setPageLoading(false));
		// yield put(BussProductSlice.setPageLoading(false));
		// yield put(CheckoutSlice.setIsShoppingCartApiCallInProgress({ apiName: "getFetchCart5G", status: false }));
	}
}

function* getBussProductPlans(params) {
	yield put(BussProductSlice.setAPIError(false));
	yield put(BussProductSlice.setPageLoading(true));
	try {
		const apiPayload = {
			viewOptions: [
				{
					name: "Position",
					value: "1",
				},
			],
			viewId: "DEEPLINKING",
			viewParam: params?.payload?.cartId,
		};
		//const  data  = {...BussPrd}
		const response = yield apiClient.post(API.GET_MARKETPLACE_PRODUCTS, apiPayload);
		const data = response?.data;
		if (data?.view) {
			yield put(BussProductSlice.setBussResponse(data.view));
		}
	} catch (err) {
		yield put(BussProductSlice.setAPIError(true));
	} finally {
		yield put(BussProductSlice.setPageLoading(false));
	}
}

function* marketplaceAddToCart(params) {
	yield put(BussProductSlice.setAPIError(false));
	yield put(BussProductSlice.setPageLoading(true));
	const globalData = yield select(selectors.globalData);

	try {
		const apiPayload = {
			"cartMeta": {
				"shoppingPath": "prospect",
				cpqCartId: globalData?.cartId,
				cpqCartVersionId: globalData?.cpqCartVersionId
			}
		};
		let requestBody = Object.assign({}, params.payload);

		//const  data  = {...BussPrd}
		const response = yield apiClient.post(API.MOBILITY_ADD_TO_CART, requestBody);
		if (response && response.data && response.data.response) {
			let sessionCartResponse = {
				prospectFlowData: response?.data?.response,
				serviceStatus: response?.data?.status,
			};
			const newStore = Utils.setStoreFromRetrieve(sessionCartResponse);
			yield put(GlobalSlice.setSessionCartData(newStore));
			yield put(BussProductSlice.setCartResponse(response?.data?.response));
			// yield put(GlobalSlice.setLoadShoppingCartWidget(true));
		}
		const data = response?.data;
		yield put(BussProductSlice.setMarketplaceAddtoCartResp(data));
	} catch (err) {
		yield put(BussProductSlice.setAPIError(true));
	} finally {
		yield put(BussProductSlice.setPageLoading(false));
	}
}
function* getBussGridwall(params) {
	yield put(setPageLoading(true));
	try {
		const globalData = yield select(selectors.globalData);
		const widgetInputParams = globalData?.widgetInputParams
		const apiPayload = {
			// "cartMeta": {
			"shoppingPath": "prospect",
			"clientId": "PROSPECT",
			"ecpd": params?.payload?.ecpd,
			newCliendId: widgetInputParams?.clientName?.value ?? ""
			// }
		}
		const resp = yield apiClient.post(API.MARKETPLACE_GRIDWALL, apiPayload);
		yield put(BussProductSlice.setSelectedAddon(undefined))
		if (resp?.data?.serviceStatus?.success) {
			if (
				(resp?.data && resp.data === null) ||
				resp.data === undefined ||
				(resp.data !== null &&
					resp.data &&
					(resp.data.deviceList === null ||
						resp.data.deviceList === undefined))
			)
				yield put(setError(true));
			else yield put(setError(false));
			const resultData = { ...resp.data, data: resp?.data }
			yield put(setGridwallList(resultData));
		} else
			throw Object.assign(new Error("Failed to fetch deviceList for Gridwall"), {
				status: resp?.status,
				data: resp?.data,
			});

	} catch (err) {
		yield put(setGridwallApiCalled(true))
		console.log(err)
	} finally {
		yield put(setGridwallApiCalled(true))
		yield put(setPageLoading(false));
	}
}
export function* getBussPDP(params) {
	yield put(setAPIError(false));
	yield put(setPageLoading(true));
	const globalData = yield select(selectors.globalData);
	const widgetInputParams = globalData?.widgetInputParams
	try {
		const { bussName, defaultEcpdId, enabledSkus } = params.payload;
		const resultData = (bussName && (String(bussName).split('-')).length > 1) ? bussName : bussName ? String(String(bussName).split(' ')[0]).toUpperCase() : ''
		const reqPayload = {
			ecpdId: widgetInputParams?.ecpdId?.value ?? window?.mbtGlobal?.ecpdId ?? defaultEcpdId ?? "",
			loginUserId: widgetInputParams?.mbLoginId?.value ?? widgetInputParams?.loginUserId?.value ?? widgetInputParams?.mbaUserId?.value ?? window?.mbtGlobal?.userId,
			rootEcpdId: widgetInputParams?.ecpdId?.value ?? window?.mbtGlobal?.ecpdId ?? defaultEcpdId ?? "",
			channel: widgetInputParams?.clientName?.value ?? "",
			enabledSkus: enabledSkus,
			"productType": resultData,
			newCliendId: widgetInputParams?.clientName?.value ?? ""
		}
		const resp = yield apiClient.post(API.MARKETPLACE_PDP, reqPayload)
		// {data:ProductDetails}
		if (
			resp.data.data === null ||
			resp.data.data === undefined ||
			(resp.data.data !== null &&
				resp.data.data &&
				(resp.data.data.deviceDetails === null ||
					resp.data.data.deviceDetails === undefined))
		)
			yield put(setError(true));
		else yield put(setError(false));
		const productDetail = { ...resp?.data, plans: resp?.data?.productPlans }
		yield put(setProductDetail({ data: productDetail }))
		yield put(setPdpDeviceDetails(resp?.data));
	} catch (err) {
		yield put(setPDPApiCalled(true))
		// yield put(MarketplaceSlice.setAPIError(true));
	} finally {
		yield put(setPDPApiCalled(true))
		yield put(setPageLoading(false));
	}
}
function* domainValidation({ payload }) {
	try {
		yield put(setPageLoading(true));
		const response = yield apiClient.post(API.MARKETPLACE_DOMAIN_VALIDATION, payload['payload'])
		if (response?.data && String(response?.data?.status).toUpperCase().includes('SUCCESS') && String(response?.data?.message).toUpperCase().includes('SUCCESS')) {
			payload.callback()
			yield put(BussProductSlice.setDomainValidation('success'))
		} else {
			if (response?.data && response?.data?.message) yield put(BussProductSlice.setDomainValidationMessage(response?.data?.message))
			throw new Error('Api Failure')
		}

	} catch (e) {
		yield put(setPageLoading(false));
		yield put(BussProductSlice.setDomainValidation('failure'))

	} finally {
		yield put(setPageLoading(false));

	}
}

function* cartValidation({ payload }) {
	try {
		const globalData = yield select(selectors.globalData);
		const widgetInputParams = globalData?.widgetInputParams
		yield put(BussProductSlice.setCartValidation(undefined))
		yield put(setPageLoading(true));
		const response = yield apiClient.post(API.MARKETPLACE_CART_VALIDATION,
			{ "newClientId": widgetInputParams?.clientname?.value ?? widgetInputParams?.clientName?.value ?? window?.mbtGlobal?.clientId ?? "" })
		if (response?.data && String(response?.data?.status).toUpperCase().includes('SUCCESS') && String(response?.data?.message).toUpperCase().includes('SUCCESS')) {
			if (payload && payload.callBack && typeof payload.callBack == 'function') payload.callBack(true)
		} else {
			const sessionCartData = globalData?.sessionCartData;
			if (sessionCartData && sessionCartData.apiResponse?.prospectFlowData.cart) {
				let issue = {}
				let productStored = []
				const { packages } = sessionCartData.apiResponse?.prospectFlowData.cart
				const getPackage = Object.values(packages).filter(data => data.buss)
				if (response?.data?.details && response?.data?.details.length) {
					getPackage.map(pack => {
						issue[pack['bnProductId']] = []
						if (!productStored.includes(pack['bnProductId'])) {
							response?.data?.details.map(data => {
								if (data['location'] === pack['bnProductId']) {
									issue[pack['bnProductId']].push((String(data['field']) + " - " + String(data['issue'])).replace(data['location'], pack['brand']))
								}
								//   if(issue[pack['bnProductId']] && issue[pack['bnProductId']].length) issue[pack['bnProductId']] = [...[pack['productName']],...issue[pack['bnProductId']]]
							})
							if (issue[pack['bnProductId']] && issue[pack['bnProductId']].length) {
								productStored.push(pack['bnProductId'])
								issue[pack['bnProductId']] = [...[pack['productName']], ...issue[pack['bnProductId']]]
							}
						}
					})

				}
				yield put(CheckoutSlice.setIssueStateCartValidation(issue))
			}
			throw new Error("Cart Validation Failed")
		}
	} catch (e) {
		yield put(setPageLoading(false));
		yield put(BussProductSlice.setCartValidation('failed'))
	} finally {
		yield put(setPageLoading(false));

	}
}

export default function* actionWatcher() {
	yield takeLatest(BussProductSlice.accessToShowMarketplace.type, accessToShowMarketplace)
	yield takeLatest(BussProductSlice.addToCart.type, addToCart);
	yield takeLatest(BussProductSlice.marketplaceAddToCart.type, marketplaceAddToCart);
	yield takeLatest(
		BussProductSlice.getBussProductPlans.type,
		getBussProductPlans
	);
	yield takeLatest(BussProductSlice.bussGridwall, getBussGridwall)
	yield takeLatest(BussProductSlice.bussPDP, getBussPDP)
	yield takeLatest(BussProductSlice.bussDomainValidation, domainValidation)
	yield takeLatest(BussProductSlice.bussCartValidation, cartValidation)
}
